import { Injectable } from '@angular/core';
import { VoterInterface, VoterInterfaceConstants } from './voter-interface';
import { OrganizationRoleVoter } from './voter/organization-role-voter';
import { TestVoter } from '../../test/security/test-voter';
import { CurrentUser } from "../providers/current-user";
import { EvaluationAthleteVoter } from "../../evaluation-athlete/security/evaluation-athlete-voter";

@Injectable({providedIn: 'root'})
export class AccessDecisionManager {
    private voters: VoterInterface[] = [];
    private allowIfAllAbstainDecisions = false;

    constructor(
        private organizationRoleVoter: OrganizationRoleVoter,
        private evaluationAthleteVoter: EvaluationAthleteVoter,
        private testVoter: TestVoter,
    ) {
        this.addVoter(organizationRoleVoter);
        this.addVoter(evaluationAthleteVoter);
        this.addVoter(testVoter);
    }

    public addVoter(voter:any) {
        this.voters.push(voter);
    }

    public decide(currentUser: CurrentUser, attributes: any, object: any = null): boolean {
        return this.decideAffirmative(currentUser, attributes, object);
    }

    /**
     * Grants access if any voter returns an affirmative response.
     *
     * If all voters abstained from voting, the decision will be based on the
     * allowIfAllAbstainDecisions property value (defaults to false).
     */
    private decideAffirmative(currentUser: CurrentUser, attributes: any, object: any = null): boolean {
        let deny = 0;
        for (const voter of this.voters) {
            const result = voter.vote(currentUser, attributes, object);

            switch (result) {
            case VoterInterfaceConstants.ACCESS_GRANTED:
                return true;

            case VoterInterfaceConstants.ACCESS_DENIED:
                ++deny;

                break;

            default:
                break;
            }
        }

        if (deny > 0) {
            return false;
        }

        return this.allowIfAllAbstainDecisions;
    }

    /**
     * Grants access if only grant (or abstain) votes were received.
     *
     * If all voters abstained from voting, the decision will be based on the
     * allowIfAllAbstainDecisions property value (defaults to false).
     */
    private decideUnanimous(currentUser: CurrentUser, attributes: any, object: any = null): boolean {
        let grant = 0;
        for (const voter of this.voters) {
            for (const attribute of attributes) {
                const result = voter.vote(currentUser, object, [attribute]);

                switch (result) {
                case VoterInterfaceConstants.ACCESS_GRANTED:
                    ++grant;
                    break;

                case VoterInterfaceConstants.ACCESS_DENIED:
                    return false;

                default:
                    break;
                }
            }
        }

        // no deny votes
        if (grant > 0) {
            return true;
        }

        return this.allowIfAllAbstainDecisions;
    }
}
